module.exports = __webpack_public_path__ + "static/img/1ortho1.3348e72e.png";